/**
 * Simple Router
 * URL-basiertes Routing für die App
 */

export type Route = '/kasse' | '/management' | '/einstellungen';

const routes: Route[] = ['/kasse', '/management', '/einstellungen'];

/**
 * Gibt die aktuelle Route zurück
 */
export function getCurrentRoute(): Route {
  const path = window.location.pathname;
  
  // Prüfe ob Route gültig ist
  if (routes.includes(path as Route)) {
    return path as Route;
  }
  
  // Default: Kasse
  return '/kasse';
}

/**
 * Navigiert zu einer Route
 */
export function navigateTo(route: Route): void {
  if (routes.includes(route)) {
    window.history.pushState({ route }, '', route);
    // Dispatch custom event für Route-Änderung
    window.dispatchEvent(new CustomEvent('routechange', { detail: { route } }));
  }
}

/**
 * Initialisiert Router
 */
export function initRouter(onRouteChange: (route: Route) => void): () => void {
  // Initial Route setzen
  const currentRoute = getCurrentRoute();
  if (window.location.pathname !== currentRoute) {
    window.history.replaceState({ route: currentRoute }, '', currentRoute);
  }
  
  // Event Listener für Browser Navigation (Zurück/Vor)
  const handlePopState = (event: PopStateEvent) => {
    const route = event.state?.route || getCurrentRoute();
    onRouteChange(route);
  };
  
  // Event Listener für programmatische Navigation
  const handleRouteChange = (event: CustomEvent<{ route: Route }>) => {
    onRouteChange(event.detail.route);
  };
  
  window.addEventListener('popstate', handlePopState);
  window.addEventListener('routechange', handleRouteChange as EventListener);
  
  // Initial Route aufrufen
  onRouteChange(currentRoute);
  
  // Cleanup Funktion
  return () => {
    window.removeEventListener('popstate', handlePopState);
    window.removeEventListener('routechange', handleRouteChange as EventListener);
  };
}

